<div class="row" style="margin-top:40px">    
    <div class="col-xs-12" style="padding:10px;">
        <div id="outer">
            <div id="summary-container" style="height:470px">
                <p class="title-3" style="text-align: center;">Amortisation</p>
                <igx-legend #legend orientation="horizontal" style="padding:3px;"></igx-legend>
                <igx-category-chart 
                    height="290px"
                    [dataSource]="chartData"
                    [legend]="legend"
                    chartType="line"
                    yAxisTitleLeftMargin="5">
                </igx-category-chart>
                <div style="display: flex;flex-direction: row;justify-content:flex-end; margin-top:20px">
                    <button (click)="refresh()" class="submit-button">Refresh</button>
                </div>
            </div>
        </div>
    </div>
</div>